import { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Router from "./routes";
import ThemeProvider from "./theme";
import { StyledChart } from "./components/chart";
import ScrollToTop from "./components/scroll-to-top";
import "./styles/styles.css";
import "./styles/developer.css";
import { apiAuth } from "./services/AllServices";
import errorHandler from "./utils/errorHandler";
import { useSelector } from "react-redux";
// ----------------------------------------------------------------------

export default function App() {
  const userPermision = useSelector((state) => state?.auth?.user);
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [data, setData] = useState();

  // useEffect(() => {
  //   if (userPermision || isLoggedIn) {
  //     const fetchData = async () => {
  //       try {
  //         const response = await apiAuth.getAdminDetails();
  //         const adminData = response?.data?.data?.adminData;
  //         setData(adminData);
  //       } catch (error) {
  //         // errorHandler(error);
  //       }
  //     };
  //     fetchData();
  //   }
  // }, [userPermision ,isLoggedIn]);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={800}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          limit={6}
        />
        <ThemeProvider>
          <ScrollToTop />
          <StyledChart />
          {/* <Router data={data} /> */}
          <Router />
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
